export const getAllHeaders = (semester) => {
    const arr = []
    for (let i of semester.list) {
        if (i.hours) {
            for (let j of i.hours) {
                arr.push({
                    name: j.alias,
                    sort: j.sorting
                })
            }
        } else continue
    }
    const sortedArr = arr.sort((a,b) => a.sort - b.sort).map(it => it.name)
    return Array.from(new Set(sortedArr))
}



